import { transformDTODate } from "@skylab-shared/core";
import { Transform } from "class-transformer";

export class DocumentExchangeRateDTO {
	@Transform(transformDTODate, { toClassOnly: true }) public date: Date;
	public manual: boolean;
	public rate: number;
	public tableNo: string | null;
	public units: number;
}
